import { ArrowUpRight, GraduationCap } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { formationPrice } from "@/lib/formation";

export const formationHref = (src) => `${process.env.REACT_APP_BACKEND_URL}/api/go/formation?src=${src}`;

/** Encadré doré vers ozentyaformation.com ; chaque clic est compté par source (fiche, guide, conseil). */
export function FormationBox({ src, testid, className = "mt-6" }) {
  const { lang } = useLang();
  const en = lang === "en";
  return (
    <a href={formationHref(src)} target="_blank" rel="noopener" data-testid={testid}
      className={`group flex items-center gap-4 rounded-sm border border-[var(--gold)] bg-[rgba(217,180,106,0.1)] p-4 transition-colors duration-300 hover:bg-[rgba(217,180,106,0.2)] ${className}`}>
      <GraduationCap className="h-8 w-8 shrink-0 text-[var(--gold)]" />
      <span className="flex-1 text-sm">
        <span className="block text-xs uppercase tracking-[0.18em] text-[var(--gold-soft)]">{en ? "Online afro hair course" : "Formation cheveux afro en ligne"}</span>
        {en ? "Learn how to care for your hair with the Ozentya Method, by Pascal Chaubo (course in French)." : "Apprenez à prendre soin de vos cheveux avec la Méthode Ozentya, par Pascal Chaubo."}
        <span className="mt-1 flex items-center gap-1 font-semibold text-[var(--gold-soft)] underline underline-offset-4">ozentyaformation.com <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5" /></span>
      </span>
    </a>
  );
}

/** Sur toutes les fiches produits : « avant d'acheter, connaissez votre cheveu » (prix de lancement tant qu'il est valable). */
export function FormationProductBox() {
  const { lang } = useLang();
  if (lang === "en") return <FormationBox src="fiche" testid="product-formation-box" />;
  const p = formationPrice();
  return (
    <a href={`${formationHref("fiche")}&to=essentiel`} target="_blank" rel="noopener" data-testid="product-formation-box"
      className="group mt-6 flex items-center gap-4 rounded-sm border border-[var(--gold)] bg-[rgba(217,180,106,0.1)] p-4 transition-colors duration-300 hover:bg-[rgba(217,180,106,0.2)]">
      <GraduationCap className="h-8 w-8 shrink-0 text-[var(--gold)]" />
      <span className="flex-1 text-sm">
        <span className="block text-xs uppercase tracking-[0.18em] text-[var(--gold-soft)]">Avant d'acheter, connaissez votre cheveu</span>
        La formation en ligne Méthode Ozentya vous apprend à diagnostiquer votre cheveu et à choisir les bons soins.{p ? <> <b>{p.now} € pour le moment</b>, {p.after} € dès le {p.until}.</> : null}
        <span className="mt-1 flex items-center gap-1 font-semibold text-[var(--gold-soft)] underline underline-offset-4">Je découvre la formation <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></span>
      </span>
    </a>
  );
}
